import { render, staticRenderFns } from "./SelectPhysicianPage.vue?vue&type=template&id=0542bb8a"
import script from "./SelectPhysicianPage.vue?vue&type=script&lang=js"
export * from "./SelectPhysicianPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports